import { AfterContentInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CookieUtilsService } from '@app/shared/utils/cookie-utils.service';
import { AnalyticsService } from '../../../../../shared/modules/analytics/services/analytics.service';
import { fadeInUp } from '../../animations/fly-animations';
import { IModalNavigator } from '../../component-lib/components/modal/navigator/modal-navigator.interface';
import { IMultiModalComponent } from '../../component-lib/components/modal/navigator/multi-modal-component.interface';
import { ChargingCardInputComponent } from '../charging-card/charging-card-input/charging-card-input.component';
import { ChargingStationInputComponent } from '../charging-station/input/input.component';
import { ChargingIntroductionModel, IntroductionType } from './introduction.model';
import { ChargingIntroductionService } from './introduction.service';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'evsb-charging-introduction',
  templateUrl: './introduction.component.html',
  animations: [fadeInUp('200ms')],
})
export class ChargingIntroductionComponent implements OnInit, AfterContentInit, IMultiModalComponent {
  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;
  @Input() skipAnalytics = false;
  @Input() public data: { introductionType: IntroductionType };
  public model: ChargingIntroductionModel;
  public modalNavigator: IModalNavigator;
  public sliderConfig: SwiperOptions;
  public canGoBack = false;
  swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 10,
  };
  public skipIntro = false;

  constructor(
    private pageService: ChargingIntroductionService,
    private analyticsService: AnalyticsService,
    private cookieUtilsService: CookieUtilsService
  ) {}

  ngOnInit(): void {
    this.model = this.pageService.getModel(this.data.introductionType);
    this.skipIntro = this.cookieUtilsService.getCookie(this.data.introductionType);
    this.sliderConfig = {
      slidesPerView: 1,
      allowTouchMove: false,
    };
  }

  ngAfterContentInit(): void {
    if (!this.skipAnalytics) {
      setTimeout(() => {
        this.analyticsIntroLogSlide(1);
      }, 0);
    }
    if (this.skipIntro) {
      this.navigateToInput();
    }
  }

  slideChanged(event: CustomEvent) {
    if (!this.skipAnalytics) {
      const [swiper] = event.detail;
      this.analyticsIntroLogSlide(swiper.activeIndex + 1);
      this.canGoBack = !this.swiper.nativeElement.swiper.isBeginning;
    }
  }

  public skip() {
    this.saveSkipIntroduction();
    this.navigateToInput();
  }

  private saveSkipIntroduction() {
    const expiredDate = new Date();
    expiredDate.setDate(expiredDate.getDate() + 7);
    this.cookieUtilsService.setCookie(this.data.introductionType, true, expiredDate);
  }

  /**
   * @description If slider is at last slide and another next event is fired,
   * modal should be navigate to next step in the flow
   */
  public next() {
    if (this.swiper.nativeElement.swiper.isEnd) {
      this.saveSkipIntroduction();
      this.navigateToInput();
    }
    this.swiper.nativeElement.swiper.slideNext();
  }

  public prev() {
    this.swiper.nativeElement.swiper.slidePrev();
  }

  private navigateToInput() {
    if (this.data.introductionType === IntroductionType.skipIntroChargingStation) {
      this.modalNavigator.goToView(ChargingStationInputComponent) as ChargingStationInputComponent;
    } else {
      this.modalNavigator.goToView(ChargingCardInputComponent) as ChargingCardInputComponent;
    }
  }

  private analyticsIntroLogSlide(slide: number) {
    this.analyticsService.push({
      event: 'b-to-b-ev-simulator-flow',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'step-charging-station',
      eventLabel: `step-${slide}`,
    });
  }
}
